import React from "react";

import { ComponentMap } from "../tools/hydrator/@types/hydrator.types";

const CtaWrapper = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/CallToActions/CtaWrapper/ctaWrapper.container"
    ).then(module => ({
        default: module.CtaWrapper,
    })),
);

const EnergyLabelContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/EnergyLabel/energyLabel.container"
    ).then(module => ({
        default: module.EnergyLabelContainer,
    })),
);

const ErrorMessages = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/ErrorMessages/errorMessages.container"
    ).then(module => ({
        default: module.ErrorMessages,
    })),
);

const FlyoutMenu = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/FlyoutMenu/flyoutMenu.container"
    ).then(module => ({
        default: module.FlyoutMenu,
    })),
);

const ProductTileAdapter = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/ProductTile/productTile.adapter"
    ).then(module => ({
        default: module.ProductTileAdapter,
    })),
);

const GlassBrickCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/GlassBrickCalculator/glassBrickCalculator.container"
    ).then(module => ({
        default: module.GlassBrickCalculator,
    })),
);

const GoogleMaps = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/GoogleMaps/googleMaps.container"
    ).then(module => ({
        default: module.GoogleMaps,
    })),
);

const Hamburger = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/Hamburger/hamburger.container"
    ).then(module => ({
        default: module.Hamburger,
    })),
);

const HasAccountModal = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Modals/HasAccountModal/hasAccountModal.container"
    ).then(module => ({
        default: module.HasAccountModal,
    })),
);

const HeaderButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/HeaderButton/headerButton.container"
    ).then(module => ({
        default: module.HeaderButtonContainer,
    })),
);

const LogoutButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Account/LogoutButton/logoutButton.container"
    ).then(module => ({
        default: module.LogoutButtonContainer,
    })),
);

const LogoutLinkContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Account/LogoutLink/logoutLink.container"
    ).then(module => ({
        default: module.LogoutLinkContainer,
    })),
);

const MessagesContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/Messages/messages.container"
    ).then(module => ({
        default: module.Messages,
    })),
);

const NewsletterSubscription = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/NewsletterSubscription/newsletterSubscription.container"
    ).then(module => ({
        default: module.NewsletterSubscription,
    })),
);

const NewsletterUnsubscribe = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/NewsletterUnsubscribeModal/newsletterUnsubscribeModal.container"
    ).then(module => ({
        default: module.NewsletterUnsubscribe,
    })),
);

const AidenIFrameComponent = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/AidenIFrame/AidenIFrame.container"
    ).then(module => ({
        default: module.AidenIFrameContainer,
    })),
);

const OrderDetailContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Order/OrderDetail/orderDetail.container"
    ).then(module => ({
        default: module.OrderDetail,
    })),
);

const OrderListContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Account/OrderList/orderList.container"
    ).then(module => ({
        default: module.OrderListContainer,
    })),
);

const OrderOverviewContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Order/OrderOverview/orderOverview.container"
    ).then(module => ({
        default: module.OrderOverview,
    })),
);

const PhoneNumberContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/PhoneNumber/phoneNumber.container"
    ).then(module => ({
        default: module.PhoneNumberContainer,
    })),
);

const PreferredStoreButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/PreferredStoreButton/preferredStoreButton.container"
    ).then(module => ({
        default: module.PreferredStoreButton,
    })),
);

const ProductFacingContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Ecorner/ProductFacing/productFacing.container"
    ).then(module => ({
        default: module.ProductFacingContainer,
    })),
);

const DiscountContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Discount/discount.container"
    ).then(module => ({
        default: module.DiscountContainer,
    })),
);

const ProfileAddressBook = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Account/Profile/ProfileAddressBook/profileAddressBook.container"
    ).then(module => ({
        default: module.ProfileAddressBook,
    })),
);

const ProfileAddressesContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Profile/Addresses/adresses.container"
    ).then(module => ({
        default: module.ProfileAddressesContainer,
    })),
);

const ProfileCredentialsContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Profile/Credentials/credentials.container"
    ).then(module => ({
        default: module.ProfileCredentialsContainer,
    })),
);

const ProfileDetailsContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Profile/Details/details.container"
    ).then(module => ({
        default: module.ProfileDetailsContainer,
    })),
);

const ProfileMenuButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Account/Profile/ProfileMenuButton/profileMenuButton.container"
    ).then(module => ({
        default: module.ProfileMenuButtonContainer,
    })),
);

const ProfilePreferencesContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Profile/Preferences/preferences.container"
    ).then(module => ({
        default: module.ProfilePreferencesContainer,
    })),
);

const ProfileSidebarContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Account/Profile/ProfileSidebar/profileSidebar.container"
    ).then(module => ({
        default: module.ProfileSidebarContainer,
    })),
);

const RequestBonusCard = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Account/RequestBonusCard/requestBonusCard.container"
    ).then(module => ({
        default: module.RequestBonusCard,
    })),
);

const ResetPasswordFormContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Account/ResetPasswordForm/resetPasswordForm.container"
    ).then(module => ({
        default: module.ResetPasswordFormContainer,
    })),
);

const RoofingCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/RoofingCalculator/roofingCalculator.container"
    ).then(module => ({
        default: module.RoofingCalculator,
    })),
);

const SafetyInfoContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/SafetyInfo/safetyInfo.container"
    ).then(module => ({
        default: module.SafetyInfoContainer,
    })),
);

const ShoppingCartContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/ShoppingCart/shoppingCart.container"
    ).then(module => ({
        default: module.ShoppingCartContainer,
    })),
);

const ShoppingCartOverviewContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/ShoppingCartOverview/shoppingCartOverview.container"
    ).then(module => ({
        default: module.ShoppingCartOverviewContainer,
    })),
);

const Sidebar = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/Sidebar/sidebar.container"
    ).then(module => ({
        default: module.SidebarContainer,
    })),
);

const SmallHeaderBackButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/SmallHeaderBackButton/smallHeaderBackButton.container"
    ).then(module => ({
        default: module.SmallHeaderBackButton,
    })),
);

const StabilizedsandCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/StabilizedSandCalculator/stabilizedSandCalculator.container"
    ).then(module => ({
        default: module.StabilizedsandCalculator,
    })),
);

const TextContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/Text/text.container"
    ).then(module => ({
        default: module.TextContainer,
    })),
);

const TileCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/TileCalculator/tileCalculator.container"
    ).then(module => ({
        default: module.TileCalculator,
    })),
);

const TooltipContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/Tooltip/tooltip.container"
    ).then(module => ({
        default: module.TooltipContainer,
    })),
);

const TransportServiceModalContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Modals/TransportServiceModal/transportServiceModal.container"
    ).then(module => ({
        default: module.TransportServiceModalContainer,
    })),
);

const TransportServiceRegistered = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/BlockSection/TransportServiceRegistered/transportServiceRegistered.container"
    ).then(module => ({
        default: module.TransportServiceRegistered,
    })),
);

const WallpaperCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/WallpaperCalculator/wallpaperCalculator.container"
    ).then(module => ({
        default: module.WallpaperCalculator,
    })),
);

const YtongCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/YtongCalculator/ytongCalculator.container"
    ).then(module => ({
        default: module.YtongCalculator,
    })),
);

const CheckoutPaymentMethodsContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Checkout/Payment/payment.container"
    ).then(module => ({
        default: module.PaymentContainer,
    })),
);

const FaqContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/Faq/faq.container"
    ).then(module => ({
        default: module.FaqContainer,
    })),
);

const InactivityMonitorContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Ecorner/InactivityMonitor/inactivityMonitor.container"
    ).then(module => ({ default: module.InactivityMonitorContainer })),
);

const TransportServiceContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/BlockSection/TransportService/transportService.container"
    ).then(module => ({ default: module.TransportServiceContainer })),
);

const VacancyGroup = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/VacancyGroup/vacancyGroup.container"
    ).then(module => ({
        default: module.VacancyGroup,
    })),
);

const ContentListBlock = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/ContentListBlock/contentListBlock.container"
    ).then(module => ({ default: module.ContentListBlock })),
);

const CartButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/CartButton/cartButton.container"
    ).then(module => ({
        default: module.CartButtonContainer,
    })),
);

const CartCheckContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/CartCheck/cartCheck.container"
    ).then(module => ({
        default: module.CartCheckContainer,
    })),
);

const CementplateCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/CementplateCalculator/cementplateCalculator.container"
    ).then(module => ({ default: module.CementplateCalculator })),
);

const CementscreedCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/CementscreedCalculator/cementscreedCalculator.container"
    ).then(module => ({ default: module.CementscreedCalculator })),
);

const CorrugatedSheetCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/CorrugatedSheetCalculator/corrugatedSheetCalculator.container"
    ).then(module => ({ default: module.CorrugatedSheetCalculator })),
);

const EPDMCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/EPDMCalculator/epdmCalculator.container"
    ).then(module => ({ default: module.EPDMCalculator })),
);

const CheckoutButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Checkout/CheckoutButton/checkoutButton.container"
    ).then(module => ({ default: module.CheckoutButton })),
);

const CheckoutDetailsButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Checkout/CheckoutDetailsButton/checkoutDetailsButton.container"
    ).then(module => ({ default: module.CheckoutDetailsButton })),
);

const ConfirmGuestContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Account/ConfirmGuest/confirmGuest.container"
    ).then(module => ({ default: module.ConfirmGuestContainer })),
);

const CheckoutCustomerContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Checkout/CheckoutCustomer/checkoutCustomer.container"
    ).then(module => ({ default: module.CheckoutCustomerContainer })),
);

const BrickCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Calculator/BrickCalculator/brickCalculator.container"
    ).then(module => ({ default: module.BrickCalculator })),
);

const BoxCounterContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/BoxCounter/boxCounter.container"
    ).then(module => ({ default: module.BoxCounterContainer })),
);

const BonusCardBalanceContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */
        "@components/Account/BonusCardBalance/bonusCardBalance.container"
    ).then(module => ({ default: module.BonusCardBalanceContainer })),
);

const AddToCartModalContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Modals/AddToCartModal/addToCartModal.container"
    ).then(module => ({ default: module.AddToCartModalContainer })),
);

const AccountButton = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Account/AccountButton/accountButton.container"
    ).then(module => ({ default: module.AccountButtonContainer })),
);

const AddBonusCard = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Account/AddBonusCard/addBonusCard.container"
    ).then(module => ({ default: module.AddBonusCard })),
);

const ConfigurableProductComponent = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Product/ConfigurableProduct/configurableProduct.component"
    ).then(module => ({
        default: module.ConfigurableProductComponent,
    })),
);

const AuthorisationProvider = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@utils/authorisation/authorisation.provider"
    ).then(module => ({
        default: module.AuthorisationProvider,
    })),
);

const AddToWishlistModal = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Wishlist/AddToWishlistModal/AddToWishlist.modal"
    ).then(module => ({
        default: module.AddToWishlistModal,
    })),
);

const WishlistSidebarContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Wishlist/WishlistSidebar/WishlistSidebar.container"
    ).then(module => ({
        default: module.WishlistSidebarContainer,
    })),
);

const WishlistMenuButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Wishlist/WishlistMenuButton/wishlistMenuButton.container"
    ).then(module => ({
        default: module.WishlistMenuButtonContainer,
    })),
);

const WishlistDetailContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Wishlist/WishlistDetail/WishlistDetail.container"
    ).then(module => ({
        default: module.WishlistDetailContainer,
    })),
);

const WishlistShareableDetailContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Wishlist/WishlistDetail/WishlistShareableDetail.container"
    ).then(module => ({
        default: module.WishlistShareableDetailContainer,
    })),
);

const WishlistInfoblockContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Wishlist/WishlistInfoblock/WishlistInfoblock.container"
    ).then(module => ({
        default: module.WishlistInfoblockContainer,
    })),
);

const SearchResults = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Search/SearchResults/searchResults.container"
    ).then(module => ({
        default: module.SearchResults,
    })),
);

const ParcelPerformContainer = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/ParcelPerform/parcelPerform.container"
    ).then(module => ({
        default: module.ParcelPerform,
    })),
);

const RequestBonusCardBlock = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Order/RequestBonusCardBlock/RequestBonusCard/requestBonusCardBlock.container"
    ).then(module => ({
        default: module.RequestBonusCardBlock,
    })),
);

const BackToTop = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Navigation/BackToTop/backToTop.container"
    ).then(module => ({
        default: module.BackToTop,
    })),
);

const BlockSection = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/BlockSection/blockSection.container"
    ).then(module => ({
        default: module.BlockSection,
    })),
);

const Iframe = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/General/Iframe/iframe.container"
    ).then(module => ({
        default: module.Iframe,
    })),
);

const FeatureSwitch = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Utils/featureSwitch/featureSwitch.container"
    ).then(module => ({
        default: module.FeatureSwitchContainer,
    })),
);

const GravelCalculator = React.lazy(() =>
    import(
        /* webpackMode: "lazy" */ "@components/Calculator/GravelCalculator/gravelCalculator.container"
    ).then(module => ({
        default: module.GravelCalculator,
    })),
);

export const componentMap: ComponentMap = {
    "hubofoundation-brand-hubo/components/calculators/bricks-calculator-component":
        BrickCalculator,
    "hubofoundation-brand-hubo/components/calculators/cementplate-calculator-component":
        CementplateCalculator,
    "hubofoundation-brand-hubo/components/calculators/cementscreed-calculator-component":
        CementscreedCalculator,
    "hubofoundation-brand-hubo/components/calculators/epdm-calculator-component":
        EPDMCalculator,
    "hubofoundation-brand-hubo/components/calculators/corrugated-sheet-calculator-component":
        CorrugatedSheetCalculator,
    "hubofoundation-brand-hubo/components/calculators/glassbrick-calculator-component":
        GlassBrickCalculator,
    "hubofoundation-brand-hubo/components/calculators/roofing-calculator-component":
        RoofingCalculator,
    "hubofoundation-brand-hubo/components/calculators/stabilizedsand-calculator-component":
        StabilizedsandCalculator,
    "hubofoundation-brand-hubo/components/calculators/tile-calculator-component":
        TileCalculator,
    "hubofoundation-brand-hubo/components/calculators/wallpaper-calculator-component":
        WallpaperCalculator,
    "hubofoundation-brand-hubo/components/calculators/ytong-calculator-component":
        YtongCalculator,
    "hubofoundation-brand-hubo/components/calculators/gravel-calculator-component":
        GravelCalculator,
    "hubofoundation-brand-hubo/components/ecorner/inactivity-monitor":
        InactivityMonitorContainer,
    "hubofoundation-brand-hubo/components/product/ecorner/facing-component":
        ProductFacingContainer,
    "hubofoundation-brand-hubo/components/product/safety-info-component":
        SafetyInfoContainer,
    "hubofoundation-brand-hubo/components/faq/FaqAccordionComponent":
        FaqContainer,
    "hubofoundation-brand-hubo/components/general/newsletter-unsubscribe-component":
        NewsletterUnsubscribe,
    "hubofoundation-brand-hubo/components/general/aiden-iframe-component":
        AidenIFrameComponent,
    "hubofoundation-brand-hubo/components/general/newsletter-subscription-component":
        NewsletterSubscription,
    "hubofoundation-brand-hubo/components/navigation/sidebar-component":
        Sidebar,
    "hubofoundation-brand-hubo/components/navigation/account-button-component":
        AccountButton,
    "hubofoundation-brand-hubo/components/checkout/order-overview-component":
        OrderOverviewContainer,
    "hubofoundation-brand-hubo/components/navigation/header-button-component":
        HeaderButtonContainer,
    "hubofoundation-brand-hubo/components/account/profile-details-component":
        ProfileDetailsContainer,
    "hubofoundation-brand-hubo/components/account/profile-credentials-component":
        ProfileCredentialsContainer,
    "hubofoundation-brand-hubo/components/account/profile-preferences-component":
        ProfilePreferencesContainer,
    "hubofoundation-brand-hubo/components/account/profile-addresses-component":
        ProfileAddressesContainer,
    "hubofoundation-brand-hubo/components/account/bonuscard-balance-component":
        BonusCardBalanceContainer,
    "hubofoundation-brand-hubo/components/account/request-bonuscard-component":
        RequestBonusCard,
    "hubofoundation-brand-hubo/components/cart/discount-component":
        DiscountContainer,
    "hubofoundation-brand-hubo/components/product/energy-label-component":
        EnergyLabelContainer,
    "hubofoundation-brand-hubo/components/account/my-order-overview-component":
        OrderDetailContainer,
    "hubofoundation-brand-hubo/components/account/my-orders-component":
        OrderListContainer,
    "hubofoundation-brand-hubo/components/phone-number": PhoneNumberContainer,
    "hubofoundation-brand-hubo/components/general/tooltip-component":
        TooltipContainer,
    "hubofoundation-brand-hubo/components/general/text-component":
        TextContainer,
    "hubofoundation-brand-hubo/components/cart/cart-component":
        ShoppingCartContainer,
    "hubofoundation-brand-hubo/components/account/logout-button-component":
        LogoutButtonContainer,
    "hubofoundation-brand-hubo/components/checkout/transport-service-component":
        TransportServiceContainer,
    "hubofoundation-brand-hubo/components/checkout/transport-service-registered-component":
        TransportServiceRegistered,
    "hubofoundation-brand-hubo/components/modal/transport-modal-component":
        TransportServiceModalContainer,
    "hubofoundation-brand-hubo/components/account/confirm-guest-component":
        ConfirmGuestContainer,
    "hubofoundation-brand-hubo/components/navigation/flyout-menu-component":
        FlyoutMenu,
    "hubofoundation-brand-hubo/components/navigation/header/hamburger-component":
        Hamburger,
    "hubofoundation-brand-hubo/components/account/reset-password-component":
        ResetPasswordFormContainer,
    "hubofoundation-brand-hubo/components/navigation/cart-button-component":
        CartButtonContainer,
    "hubofoundation-brand-hubo/components/cart/cart-overview-component":
        ShoppingCartOverviewContainer,
    "hubofoundation-brand-hubo/components/general/cta-wrapper-component":
        CtaWrapper,
    "hubofoundation-brand-hubo/components/product/box-counter-container":
        BoxCounterContainer,
    "hubofoundation-brand-hubo/components/cart/checkout-details-button-component":
        CheckoutDetailsButton,
    "hubofoundation-brand-hubo/components/cart/checkout-button-component":
        CheckoutButton,
    "hubofoundation-brand-hubo/components/general/error-messages-component":
        ErrorMessages,
    "hubofoundation-brand-hubo/components/general/link-list-tile-component":
        ContentListBlock,
    "hubofoundation/components/store/preferred-store-button-component":
        PreferredStoreButton,
    "hubofoundation-brand-hubo/components/navigation/small-header-back-button-component":
        SmallHeaderBackButton,
    "hubofoundation-brand-hubo/components/account/profile-sidebar-component":
        ProfileSidebarContainer,
    "hubofoundation-brand-hubo/components/account/profile-menu-button-component":
        ProfileMenuButtonContainer,
    "hubofoundation-brand-hubo/components/account/profile-addressbook-component":
        ProfileAddressBook,
    "hubofoundation-brand-hubo/components/product/product-tile-component":
        ProductTileAdapter,
    "hubofoundation-brand-hubo/components/account/add-bonuscard-component":
        AddBonusCard,
    "hubofoundation-brand-hubo/components/general/message-component":
        MessagesContainer,
    "hubofoundation-brand-hubo/components/navigation/logout-link-component":
        LogoutLinkContainer,
    "hubofoundation-brand-hubo/components/checkout/checkout-details/":
        CheckoutCustomerContainer,
    "hubofoundation-brand-hubo/components/checkout/payment/methods":
        CheckoutPaymentMethodsContainer,
    "hubofoundation-brand-hubo/components/store/google-maps-component":
        GoogleMaps,
    "hubofoundation-brand-hubo/components/modal/add-to-cart-modal-component":
        AddToCartModalContainer,
    "hubofoundation-brand-hubo/components/modal/has-account-modal-component":
        HasAccountModal,
    "hubofoundation-brand-hubo/components/checkout/cart-check-component":
        CartCheckContainer,
    "hubofoundation-brand-hubo/components/vacancy/vacancy-group-component":
        VacancyGroup,
    "hubofoundation-brand-hubo/components/product/configurable-product-component":
        ConfigurableProductComponent,
    "hubofoundation-brand-hubo/components/general/authorisation-provider-component":
        AuthorisationProvider,
    "hubofoundation-brand-hubo/components/wishlist/wishlist-modal":
        AddToWishlistModal,
    "hubofoundation-brand-hubo/components/wishlist/wishlist-sidebar-component":
        WishlistSidebarContainer,
    "hubofoundation-brand-hubo/components/wishlist/wishlist-detail-component":
        WishlistDetailContainer,
    "hubofoundation-brand-hubo/components/wishlist/wishlist-shareable-detail-component":
        WishlistShareableDetailContainer,
    "hubofoundation-brand-hubo/components/wishlist/wishlist-menu-button-component":
        WishlistMenuButtonContainer,
    "hubofoundation-brand-hubo/components/wishlist/wishlist-info-block-component":
        WishlistInfoblockContainer,
    "hubofoundation-brand-hubo/components/general/parcel-perform-component":
        ParcelPerformContainer,
    "hubofoundation-brand-hubo/components/checkout/request-bonuscard-block-component":
        RequestBonusCardBlock,
    "hubofoundation-brand-hubo/components/navigation/back-to-top-component":
        BackToTop,
    "hubofoundation-brand-hubo/components/block-section": BlockSection,
    "hubofoundation-brand-hubo/components/general/iframe": Iframe,
    "hubofoundation-brand-hubo/components/general/feature-switch-component":
        FeatureSwitch,
};
